import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ICustomerCare } from '../../../../core/interfaces/customer-care.interface';
import { EmailService, IEmailCustomerCareRequest } from '../../../side-nav/email/email.service';
import { RoutingService } from '../../../../services/routing/routing.service';
import { EmailValidator } from '../../../../shared/validators/email.validator';

@Component({
  selector: 'customer-care',
  templateUrl: './customer-care.component.html',
  styleUrls: ['./customer-care.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CustomerCareComponent implements OnInit, OnChanges {
  @Input() customerCareDetails: ICustomerCare; // create an interface for this one

  customerCareForm: UntypedFormGroup;
  detailedInforText =
    'Enter detailed information on function being performed, error message, ILL number, etc.';

  private _phoneNumberPattern = '^((\\+1-?)|0)?[0-9]{10}$';

  constructor(
    private _emailService: EmailService,
    private _fb: UntypedFormBuilder,
    private _routingService: RoutingService,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.customerCareDetails) {
      this._componentBindings(changes.customerCareDetails.currentValue);
    }
  }

  ngOnInit(): void {
    if (this.customerCareDetails) {
      this._componentBindings(this.customerCareDetails);
    }
  }

  private _componentBindings(data): void {
    this.customerCareDetails = data;
    this._createCustomerCareForm();
  }

  async submitCustomerCareForm(): Promise<void> {
    const email_request: IEmailCustomerCareRequest = {
      toAddress: this.customerCareDetails.toEmailAddressOnSubmit,
      messageBody: this._buildEmailRequestMessage(),
    };
    await this._emailService.sendEmailCustomerCareAsync(email_request);
  }

  private _buildEmailRequestMessage(): string {
    let emailMessage = '';
    emailMessage += `Name:${this.customerCareForm.value.name}\r\n`;
    emailMessage += `Phone:${this._normalizePhoneNumber()}\r\n`;
    emailMessage += `Browser Name:${this.customerCareForm.value.browserName}\r\n`;
    emailMessage += `Library Name:${this.customerCareForm.value.libraryName}\r\n`;
    emailMessage += `Library Code:${this.customerCareForm.value.libraryCode}\r\n`;
    emailMessage += `Email Address:${this.customerCareForm.value.email}\r\n`;
    emailMessage += `Product:${this.customerCareForm.value.productName}\r\n`;
    emailMessage += `Subject of Problem:${this.customerCareForm.value.problemSubject}\r\n`;
    emailMessage += `Enter detailed information on function being performed, error message, ILL number, etc.:${this.customerCareForm.value.detailedInformation}\r\n`;
    return emailMessage;
  }

  private _normalizePhoneNumber(): string {
    return this.customerCareForm.value.phone.replace('-', '');
  }

  private _createCustomerCareForm(): void {
    this.customerCareForm = this._fb.group({
      name: ['', [Validators.required, Validators.minLength(2)]],
      phone: ['', [Validators.required, Validators.pattern(this._phoneNumberPattern)]],
      libraryCode: ['', [Validators.required, Validators.minLength(2)]],
      browserName: ['', [Validators.required, Validators.minLength(2)]],
      libraryName: ['', [Validators.required, Validators.minLength(2)]],
      email: ['', [Validators.required, EmailValidator()]],
      productName: ['', [Validators.required, Validators.minLength(5)]],
      problemSubject: ['', [Validators.required, Validators.minLength(5)]],
      detailedInformation: ['', [Validators.required, Validators.minLength(5)]],
    });
  }

  get form() {
    return this.customerCareForm.controls;
  }

  cancel(): void {
    this._routingService.goToPreviousUrl();
  }
}
